import { Button, CardItem, Typography } from "@hellocarbo/lasagne";
import { Download } from "lucide-react";
import { PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router";

import useSegmentEvent from "@/hooks/useSegmentEvent";

import UpsellModal from "../Communicate/UpsellModal"; // Move when exports are removed from the Communicate page

export type TExport = { url?: string; name: string; segmentEventName: string };

interface ExportCardProps extends PropsWithChildren {
  title: string;
  description: string;
  exports: Array<TExport>;
  additionalInformation?: ReactNode;
}

function ExportCard({
  title,
  description,
  exports,
  additionalInformation,
}: ExportCardProps) {
  const { sendSegmentEvent } = useSegmentEvent();

  if (!exports.length) {
    return null;
  }

  return (
    <CardItem>
      <Typography step="1" weight="bold" as="h2" className="mb-2xs">
        {title}
      </Typography>
      <Typography className="mb-sm">{description}</Typography>
      <div className="gap-xs flex flex-wrap">
        {exports.map((exp) => (
          <UpsellModal key={exp.name}>
            <Button
              as={Link}
              to={exp.url || ""}
              intent="secondary"
              shape="soft"
              onClick={() => sendSegmentEvent(exp.segmentEventName)}
            >
              <Download className="size-sm" />
              {exp.name}
            </Button>
          </UpsellModal>
        ))}
      </div>
      {additionalInformation && (
        <Typography className="mt-sm">{additionalInformation}</Typography>
      )}
    </CardItem>
  );
}

export default ExportCard;
